module.exports = __webpack_public_path__ + "static/media/iv_otp.b187da43.svg";